import { render, staticRenderFns } from "./icon1.vue?vue&type=template&id=0bcdfe84&scoped=true&"
import script from "./icon1.vue?vue&type=script&lang=js&"
export * from "./icon1.vue?vue&type=script&lang=js&"
import style0 from "./icon1.vue?vue&type=style&index=0&id=0bcdfe84&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdfe84",
  null
  
)

export default component.exports